import { observable, action, runInAction } from 'mobx'
import PT from 'prop-types'
import R from 'ramda'
import logger from '@vimcar/shared-utils/logger'

import { O } from '#utils/rx'
import i18n from '#utils/i18n'

const tp = i18n.prefix('components.ProfileCard')

const fields = [
  'gender',
  'firstname',
  'lastname',
]

const mkStore = (
  { registerObservable },
  props,
  { users }
) => {
  const store = observable({
    editing: false,
    loading: false,
    error: null,
    valid: true,
    fields: observable.ref(fields),
    data: observable.ref(
      R.pick(fields, users.self)
    ),
    handleEdit: action(() => {
      store.editing = true
    }),
    handleChange: action((profile) => {
      if (profile) {
        store.valid = true
        store.data = profile
      } else {
        store.valid = false
      }
    }),
    handleSave: action(() => {
      if (!store.valid) return
      store.editing = false
      store.error = null
      registerObservable(
        users.self.updateProfile(store.data)
          .catch((err) => runInAction(() => {
            logger.error(err)
            store.editing = true
            store.error = tp('failed-to-save')
            return O.empty()
          }))
      )
    }),
  })

  return store
}

mkStore.contextTypes = {
  users: PT.object.isRequired,
}

export default mkStore
